import { html, LitElement } from 'lit';
import { classMap } from 'lit/directives/class-map.js';
import { ifDefined } from 'lit/directives/if-defined.js';

import Styles from './vm-button-link.scss';

export default class VmButtonLink extends LitElement {
    static styles = Styles;

    static properties = {
        href: { type: String },
        target: { type: String },
        rel: { type: String },
        title: { type: String },
        variant: { type: String },
        size: { type: String },
        custom: { type: String },
        active: { type: Boolean },
        minWidth: { type: Boolean, attribute: 'min-width' },
    };

    constructor() {
        super();
        this.active = false;
        this.minWidth = false;
    }

    get linkClasses() {
        const classes = {
            'vm-button': true,
            [`vm-button--${this.variant}`]: !!this.variant,
            [`vm-button--${this.size}`]: !!this.size,
            'vm-button--active': this.active,
            'vm-button--min-width': this.minWidth,
        };

        // Support space-separated custom classes (e.g., "comment-cta thumb-up")
        if (this.custom) {
            this.custom.split(/\s+/).forEach((customClass) => {
                if (customClass) {
                    classes[`vm-button--${customClass}`] = true;
                }
            });
        }

        return classes;
    }

    render() {
        return html`
            <a
                href=${ifDefined(this.href)}
                target=${ifDefined(this.target)}
                rel=${ifDefined(this.rel)}
                title=${ifDefined(this.title)}
                class=${classMap(this.linkClasses)}
                part="link"
            >
                <slot></slot>
            </a>
        `;
    }
}
